import { render, staticRenderFns } from "./agentSuccess.vue?vue&type=template&id=805712f4&scoped=true"
import script from "./agentSuccess.vue?vue&type=script&lang=js"
export * from "./agentSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805712f4",
  null
  
)

export default component.exports